import { handleActions } from 'redux-actions'
import Immutable from 'immutable'

import * as actions from '../actions/queryTasks';

const initialState = Immutable.fromJS({
  data: [],
  // export: {},
  loading: false,
  loaded: false
})

export default handleActions({
  // 任务列表展示
  [actions.getTasksSucceeded](state, { payload }) {
    // console.log('-----------------------------')
    return state.set('loading', false).set('loaded', true)
     .set('data', Immutable.fromJS(payload.data));
  },
  [actions.getTasksFailed](state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  },
  [actions.gettaskDetailsSucceeded](state, { payload }) {
    return state.set('loading', false).set('loaded', true)
      .set('data', Immutable.fromJS(payload.data));
  },
  [actions.gettaskDetailsFailed](state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  },
}, initialState)



// WEBPACK FOOTER //
// ./reducers/queryTasks.js